import { AssessmentButton, InputField } from "ui-components";
import "./AddReport.scss";
import { useTranslation } from "react-i18next";
import Loader from "../../../components/Loader/Loader";
interface AddReport {
  value: string;
  placeHolder: string;
  btnName: string;
  setFn: any;
  handleSubmit: () => void;
  reportLoading?: boolean;
}
const AddReport: React.FC<AddReport> = ({
  value,
  placeHolder,
  btnName,
  setFn,
  handleSubmit,
  reportLoading = false,
}) => {
  const handlechange = (id: null, value: any) => {
    setFn(value);
  };
  const { t } = useTranslation();
  return (
    <div className="Reports ">
      <div className="reportInputField w-100">
        <InputField
          additionalProps={{
            as: "textarea",
            rows: 2,
            style: { resize: "none" },
          }}
          value={value}
          placeholder={placeHolder}
          onChange={(e) => {
            handlechange(null, e);
          }}
        />
      </div>
      <div className="reportBtn mt-3">
        <AssessmentButton
          onClick={() => {
            handleSubmit();
          }}
          disabled={reportLoading || value?.length < 1}
        >
          {reportLoading ? (
            <div className="d-flex align-items-center gap-2">
              {t("GENERAL.LOADING")}
              <div className="disableLoading">
                <Loader />
              </div>
            </div>
          ) : (
            btnName
          )}
        </AssessmentButton>
      </div>
    </div>
  );
};

export default AddReport;
